import { useContext } from "react";
import { ApplicationContext } from "./ApplicationContext";

export default function useApplicationContext() {
    return useContext(ApplicationContext);
}
